/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  googleMapsApiKey: 'AIzaSyCqhadmQ75-upzI4bb8CymHWgPPcEY80yE',
  apiUrl: 'https://dev.builder.e-leads.it/api/',
  productID: "price_1HhWpzAZUJ0Myx5hnhsDQAiz",
  firebase: {
    apiKey: "AIzaSyA5qIaZ0WHbVeRTKOJ-yv0yKzjUCfHzodE",
    authDomain: "e-leads-builder-dev.firebaseapp.com",
    projectId: "e-leads-builder-dev",
    storageBucket: "e-leads-builder-dev.appspot.com",
    messagingSenderId: "321359761531",
    appId: "1:321359761531:web:1d40ced4ea34a852c592de"
  },
  stripeToken: 'pk_test_Hn6AYMHvAn25dPtDhPIQIV0R',
  paddle: {
    vendor: 123286,
    apiKey: "1cd23aa5681a9835706f5886100623a9",
    product: 636839,
    product_annually: 637590
  }
};
